import useTestTag from '../../../common/hooks/use-test-tag';
import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import { DomElementAlignment, DomTargetPosition } from '../../enums';
import ErrorLabel from '../../labels/error-label';
import FieldLabel from '../../labels/field-label';
import TooltipLegacy from '../../tooltip-component/tooltip.component';

export interface GeolocationValue {
  address: string;
  latitude: number;
  longitude: number;
}

const Geolocation = ({ name, label, error, value, labelStyles }: DynamicFieldComponentProps<GeolocationValue>) => {
  const tagCreator = useTestTag(label || name || '');
  const tooltipDescription = value ? `Latitude: ${value.latitude}, Longitude: ${value.longitude}` : '';

  return (
    <div>
      {label && name && (
        <div className="flex">
          <FieldLabel label={label} name={name} labelStyles={labelStyles} />
        </div>
      )}
      <div ref={tagCreator('value')} className="text-sm py-1">
        <TooltipLegacy
          description={tooltipDescription}
          tooltipClassName={'bg-mono-1 mt-1.5 ml-1.5 text-sm'}
          tooltipTargetPosition={DomTargetPosition.BottomRight}
          tooltipAlignment={DomElementAlignment.TopRight}
          wrapperClassName={'inline-flex'}
          tooltipZIndexCheck={true}
          disabled={!value}
        >
          {value?.address ?? ''}
        </TooltipLegacy>
      </div>
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </div>
  );
};

export default Geolocation;
